import React from "react";
import { QUICK_PICKS, SAMPLE_QUERIES, ORACLE_TEST_IDS } from "@/constants/oracle";

export default function QuickPicks({ mode, onPick, disabled }) {
  const picks = QUICK_PICKS[mode] || [];
  const samples = SAMPLE_QUERIES[mode] || [];
  return (
    <div className="oracle-quickpicks">
      <div className="oracle-quickpicks__row">
        <span className="oracle-chip-label">QUICK PICKS</span>
        {picks.map((p, i) => (
          <button
            key={`qp-${mode}-${i}`}
            type="button"
            className="oracle-chip oracle-chip--gold"
            data-testid={ORACLE_TEST_IDS.quickPick(mode, i)}
            onClick={() => onPick(p.prompt)}
            disabled={disabled}
            title={p.prompt}
          >
            {p.label}
          </button>
        ))}
      </div>
      <div className="oracle-quickpicks__row">
        <span className="oracle-chip-label">SAMPLE PROMPTS</span>
        {samples.map((q, i) => (
          <button
            key={`sp-${mode}-${i}`}
            type="button"
            className="oracle-chip oracle-chip--ghost"
            data-testid={ORACLE_TEST_IDS.sampleQuery(mode, i)}
            onClick={() => onPick(q)}
            disabled={disabled}
            title={q}
          >
            {q.length > 70 ? q.slice(0, 67) + "…" : q}
          </button>
        ))}
      </div>
    </div>
  );
}
